function appendBase(url, base) {
  if (!url) return null;
  const value = String(url).trim();
  if (!value) return null;
  if (value.startsWith('http://') || value.startsWith('https://')) return value;
  if (value.startsWith('//')) return `https:${value}`;
  const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base;
  const normalizedPath = value.startsWith('/') ? value : `/${value}`;
  return `${normalizedBase}${normalizedPath}`;
}

export function resolvePhotoUrl(photo, baseUrl = '') {
  if (!photo) return null;

  if (typeof photo === 'string') {
    return appendBase(photo, baseUrl);
  }

  if (typeof photo !== 'object') return null;

  const candidates = [
    photo.full_url,
    photo.url,
    photo.preview_url,
    photo.image_url,
    photo.photo_url,
  ];

  for (let i = 0; i < candidates.length; i += 1) {
    const resolved = appendBase(candidates[i], baseUrl);
    if (resolved) return resolved;
  }

  return null;
}

export function getFirstCarouselPhotoUrl(item, baseUrl = '') {
  if (!item || typeof item !== 'object') return null;

  const collections = [
    item.carousel_photos,
    item.photos,
    item.owner_photos,
    item.images,
  ];

  for (let i = 0; i < collections.length; i += 1) {
    const collection = collections[i];
    if (!Array.isArray(collection) || !collection.length) continue;
    const resolved = resolvePhotoUrl(collection[0], baseUrl);
    if (resolved) return resolved;
  }

  return resolvePhotoUrl(item.photo, baseUrl)
    || resolvePhotoUrl(item.photo_url, baseUrl)
    || resolvePhotoUrl(item.image_url, baseUrl)
    || resolvePhotoUrl(item.image, baseUrl)
    || resolvePhotoUrl(item.thumbnail, baseUrl)
    || resolvePhotoUrl(item.cover_url, baseUrl)
    || resolvePhotoUrl(item.cover, baseUrl);
}
